import "./css/ProgressBar.css";

export default function ProgressBar({ currentStep }) {
  const stepClasses = "step-classes";
  const activeStepClasses = "active active-step-classes";
  const barClasses = "bar bar-classes";
  const labelClasses = "label-classes";

  return (
    <div className="vertical-progress-bar">
      <div className="progress-bar-wrap">
        <span className="grad-top"></span>
        <span className="grad-bottom"></span>
        <div className={`${currentStep > 0 && "active"} ${barClasses} first`} />
        <div
          className={`step ${
            currentStep >= 1 && activeStepClasses
          } ${stepClasses}`}
        >
          <span className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="19.486"
              viewBox="0 0 20 19.486"
            >
              <g
                id="Group_3532"
                data-name="Group 3532"
                transform="translate(-2 -2.257)"
              >
                <path
                  id="Path_1211"
                  data-name="Path 1211"
                  d="M5.319,4.313H18.681A3.323,3.323,0,0,1,22,7.632V18.424a3.323,3.323,0,0,1-3.319,3.319H5.319A3.323,3.323,0,0,1,2,18.424V7.632A3.323,3.323,0,0,1,5.319,4.313ZM18.681,20.243A1.822,1.822,0,0,0,20.5,18.424V7.632a1.821,1.821,0,0,0-1.819-1.819H5.319A1.822,1.822,0,0,0,3.5,7.632V18.424a1.822,1.822,0,0,0,1.819,1.819Z"
                  fill="#d72c8e"
                />
                <path
                  id="Path_1212"
                  data-name="Path 1212"
                  d="M21.25,10.951H2.75a.75.75,0,1,1,0-1.5h18.5a.75.75,0,0,1,0,1.5Z"
                  fill="#d72c8e"
                />
                <path
                  id="Path_1213"
                  data-name="Path 1213"
                  d="M17.139,7.868a.75.75,0,0,1-.75-.75V3.007a.75.75,0,0,1,1.5,0V7.118A.75.75,0,0,1,17.139,7.868Z"
                  fill="#d72c8e"
                />
                <path
                  id="Path_1214"
                  data-name="Path 1214"
                  d="M6.861,7.868a.75.75,0,0,1-.75-.75V3.007a.75.75,0,0,1,1.5,0V7.118A.75.75,0,0,1,6.861,7.868Z"
                  fill="#d72c8e"
                />
              </g>
            </svg>
          </span>
          <span className={labelClasses}>Availability</span>
        </div>
        <div className={`${currentStep > 1 && "active"} ${barClasses}`} />
        <div
          className={`step ${
            currentStep >= 2 && activeStepClasses
          } ${stepClasses}`}
        >
          <span className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g
                id="Group_3533"
                data-name="Group 3533"
                transform="translate(-2 -2)"
              >
                <path
                  id="Path_1215"
                  data-name="Path 1215"
                  d="M16.721,22H5.119A3.119,3.119,0,0,1,2,18.863V7.279A3.106,3.106,0,0,1,5.124,4.159H9.559a.75.75,0,0,1,0,1.5H5.119A1.606,1.606,0,0,0,3.5,7.274V18.867A1.619,1.619,0,0,0,5.119,20.5h11.6a1.619,1.619,0,0,0,1.619-1.619V14.441a.75.75,0,0,1,1.5,0v4.439A3.119,3.119,0,0,1,16.721,22Z"
                  fill="#d72c8e"
                />
                <path
                  id="Path_1216"
                  data-name="Path 1216"
                  d="M10.362,17.915H8.2A2.112,2.112,0,0,1,6.085,15.8V13.638A2.1,2.1,0,0,1,6.7,12.157l9.534-9.534a2.112,2.112,0,0,1,3,0l2.149,2.149a2.112,2.112,0,0,1,0,3l-9.53,9.53a2.1,2.1,0,0,1-1.48.615ZM17.729,3.5a.611.611,0,0,0-.434.181L7.76,13.215a.606.606,0,0,0-.175.426V15.8a.612.612,0,0,0,.612.612h2.164a.608.608,0,0,0,.426-.177l9.53-9.53a.612.612,0,0,0,0-.871L18.165,3.683a.612.612,0,0,0-.436-.183Z"
                  fill="#d72c8e"
                />
                <path
                  id="Path_1217"
                  data-name="Path 1217"
                  d="M19.091,9.745a.748.748,0,0,1-.53-.22L14.475,5.44a.75.75,0,1,1,1.061-1.061l4.085,4.085a.75.75,0,0,1-.53,1.28Z"
                  fill="#d72c8e"
                />
              </g>
            </svg>
          </span>
          <span className={labelClasses}>Your Quote</span>
        </div>

        <div className={`${currentStep > 2 && "active"} ${barClasses}`} />

        <div
          className={`step ${
            currentStep >= 3 && activeStepClasses
          } ${stepClasses}`}
        >
          <span className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.92"
              height="20"
              viewBox="0 0 17.92 20"
            >
              <g
                id="Group_3534"
                data-name="Group 3534"
                transform="translate(-3.04 -2)"
              >
                <path
                  id="Path_1218"
                  data-name="Path 1218"
                  d="M12,22a3.2,3.2,0,0,1-1.649-.457L4.6,18.1a3.227,3.227,0,0,1-1.147-1.175l0-.006a3.3,3.3,0,0,1-.412-1.567s0,0,0-.006V8.277A3.211,3.211,0,0,1,4.6,5.512l.032-.018,5.738-3.06a3.264,3.264,0,0,1,3.252,0l5.738,3.06.032.018A3.211,3.211,0,0,1,20.96,8.28v7.062s0,0,0,.006a3.3,3.3,0,0,1-.412,1.567l0,.006A3.228,3.228,0,0,1,19.4,18.1l-5.749,3.447A3.2,3.2,0,0,1,12,22ZM4.762,16.184a1.724,1.724,0,0,0,.612.625l5.75,3.448a1.7,1.7,0,0,0,1.752,0l5.75-3.448a1.725,1.725,0,0,0,.612-.625,1.792,1.792,0,0,0,.222-.846V8.277a1.711,1.711,0,0,0-.819-1.469L12.909,3.752l-.024-.013a1.764,1.764,0,0,0-1.771,0l-.024.013L5.359,6.808A1.711,1.711,0,0,0,4.54,8.274v7.063A1.791,1.791,0,0,0,4.762,16.184Z"
                  fill="#d72c8e"
                />
                <path
                  id="Path_1219"
                  data-name="Path 1219"
                  d="M12,12.559a.75.75,0,0,1-.387-1.393L19.5,6.435a.75.75,0,0,1,.772,1.286l-7.881,4.731A.747.747,0,0,1,12,12.559Z"
                  fill="#d72c8e"
                />
                <path
                  id="Path_1220"
                  data-name="Path 1220"
                  d="M12,22a.75.75,0,0,1-.75-.75V12.234L3.733,7.721A.75.75,0,1,1,4.5,6.435l7.881,4.731a.75.75,0,0,1,.364.643V21.25A.75.75,0,0,1,12,22Z"
                  fill="#d72c8e"
                />
                <path
                  id="Path_1221"
                  data-name="Path 1221"
                  d="M16.381,13.684a.75.75,0,0,1-.75-.75V9.618L7.7,5.176a.75.75,0,0,1,.733-1.309l8.316,4.657a.75.75,0,0,1,.384.654v3.755A.75.75,0,0,1,16.381,13.684Z"
                  fill="#d72c8e"
                />
              </g>
            </svg>
          </span>
          <span className={labelClasses}>Customise</span>
        </div>

        <div className={`${currentStep > 3 && "active"} ${barClasses}`} />

        <div
          className={`step ${
            currentStep === 4 && activeStepClasses
          } ${stepClasses}`}
        >
          <span className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21.5"
              height="21.5"
              viewBox="0 0 21.5 21.5"
            >
              <g id="truck-fast-svgrepo-com" transform="translate(-1.25 -1.25)">
                <path
                  id="Path_1222"
                  data-name="Path 1222"
                  d="M13,14.75H12a.75.75,0,0,1,0-1.5h1A1.251,1.251,0,0,0,14.25,12V2.75H6A3.248,3.248,0,0,0,3.165,4.415a.75.75,0,0,1-1.31-.73A4.749,4.749,0,0,1,6,1.25h9a.75.75,0,0,1,.75.75V12A2.753,2.753,0,0,1,13,14.75Z"
                  fill="#4acbbb"
                />
                <path
                  id="Path_1223"
                  data-name="Path 1223"
                  d="M19,20.75H18a.75.75,0,0,1-.75-.75,1.25,1.25,0,0,0-2.5,0,.75.75,0,0,1-.75.75H10A.75.75,0,0,1,9.25,20a1.25,1.25,0,0,0-2.5,0,.75.75,0,0,1-.75.75H5A3.754,3.754,0,0,1,1.25,17a.75.75,0,0,1,1.5,0A2.253,2.253,0,0,0,5,19.25h.354a2.75,2.75,0,0,1,5.292,0h2.708a2.75,2.75,0,0,1,5.292,0H19A2.253,2.253,0,0,0,21.25,17V14.75H19A1.752,1.752,0,0,1,17.25,13V10A1.752,1.752,0,0,1,19,8.25L17.929,6.382A1.268,1.268,0,0,0,16.84,5.75H15.75V12A2.753,2.753,0,0,1,13,14.75H12a.75.75,0,0,1,0-1.5h1A1.251,1.251,0,0,0,14.25,12V5A.75.75,0,0,1,15,4.25h1.84a2.775,2.775,0,0,1,2.389,1.383l1.712,2.994A.75.75,0,0,1,20.29,9.75H19a.253.253,0,0,0-.25.25v3a.253.253,0,0,0,.25.25h3a.75.75,0,0,1,.75.75v3A3.754,3.754,0,0,1,19,20.75Z"
                  fill="#4acbbb"
                />
                <path
                  id="Path_1224"
                  data-name="Path 1224"
                  d="M8,22.75A2.75,2.75,0,1,1,10.75,20,2.753,2.753,0,0,1,8,22.75Zm0-4A1.25,1.25,0,1,0,9.25,20,1.251,1.251,0,0,0,8,18.75Z"
                  fill="#4acbbb"
                />
                <path
                  id="Path_1225"
                  data-name="Path 1225"
                  d="M16,22.75A2.75,2.75,0,1,1,18.75,20,2.753,2.753,0,0,1,16,22.75Zm0-4A1.25,1.25,0,1,0,17.25,20,1.251,1.251,0,0,0,16,18.75Z"
                  fill="#4acbbb"
                />
                <path
                  id="Path_1226"
                  data-name="Path 1226"
                  d="M22,14.75H19A1.752,1.752,0,0,1,17.25,13V10A1.752,1.752,0,0,1,19,8.25h1.29a.75.75,0,0,1,.652.379l1.71,3a.75.75,0,0,1,.1.371v2A.75.75,0,0,1,22,14.75Zm-3-5a.253.253,0,0,0-.25.25v3a.253.253,0,0,0,.25.25h2.25V12.2l-1.4-2.449Z"
                  fill="#4acbbb"
                />
                <path
                  id="Path_1227"
                  data-name="Path 1227"
                  d="M8,8.75H2a.75.75,0,0,1,0-1.5H8a.75.75,0,0,1,0,1.5Z"
                  fill="#4acbbb"
                />
                <path
                  id="Path_1228"
                  data-name="Path 1228"
                  d="M6,11.75H2a.75.75,0,0,1,0-1.5H6a.75.75,0,0,1,0,1.5Z"
                  fill="#4acbbb"
                />
                <path
                  id="Path_1229"
                  data-name="Path 1229"
                  d="M4,14.75H2a.75.75,0,0,1,0-1.5H4a.75.75,0,0,1,0,1.5Z"
                  fill="#4acbbb"
                />
              </g>
            </svg>
          </span>
          <span className={labelClasses}>Delivery</span>
        </div>

        <div className={`${currentStep >= 4 && "active"} ${barClasses} last`} />
      </div>
    </div>
  );
}
